import { CreatedAtFilter } from "@/data/filters/object";

export const DefaultFilters = () => [CreatedAtFilter()];
